import { useNavigate, useParams } from "react-router-dom";
import { useGetPursuitTasks } from "./useGetPursuitTasks";
import { CalendarIcon, ChevronsDown, CircleX } from "lucide-react";

import DatePicker from "@/components/ui/date-picker";
import { useMemo, useState } from "react";
import { taskPriorities } from "./TaskPrioritySelect";

import { MultiSelect } from "@/components/ui/multi-select";
import PursuitTasksKanban, { PursuitTaskCreator } from "./PursuitTasksKanban";
import { PursuitCalendar } from "../PursuitCalendar";
import { useUiStore } from "@/stores/UiStore";
import KanbanFilters from "../KanbanFilters";

export default function PursuitTasks() {
  const { pursuit_id } = useParams();
  const { data, isLoading } = useGetPursuitTasks(pursuit_id);
  const [activeFilters, setActiveFilters] = useState({
    priority: [],
    date: null,
  });
  const togglePursuitTaskCalendarView = useUiStore(
    (state) => state.togglePursuitTaskCalendarView
  );
  const isPursuitTaskCalendarView = useUiStore(
    (state) => state.pursuitTaskCalendarView
  );
  const navigate = useNavigate();
  const filteredData = useMemo(() => {
    if (!data) return [];

    return data.filter((task) => {
      const matchesPriority =
        activeFilters.priority.length === 0 ||
        activeFilters.priority.includes(task.priority);

      const matchesDate =
        !activeFilters.date ||
        new Date(task.due_date) <= new Date(activeFilters.date);

      return matchesPriority && matchesDate;
    });
  }, [data, activeFilters]);
  return (
    <div className="flex flex-col container">
      <KanbanFilters
        calendarSwitched={isPursuitTaskCalendarView}
        onCalendarSwitchClicked={togglePursuitTaskCalendarView}
        renderNewButton={() => <PursuitTaskCreator pursuitId={pursuit_id} />}
        renderFilters={() => (
          <>
            <MultiSelect
              options={taskPriorities}
              onValueChange={(values) => {
                setActiveFilters({ ...activeFilters, priority: values });
              }}
              placeholder={
                <span className="flex items-center hover:text-foreground gap-1">
                  <ChevronsDown className="size-3.5" /> Priority
                </span>
              }
              maxCount={1}
              className="border-x border-y-0 rounded-none min-h-8 hover:bg-muted h-full"
            />

            <div
              className="hover:bg-muted"
              style={{
                backgroundColor: activeFilters.date
                  ? "hsl(var(--secondary))"
                  : undefined,
              }}
            >
              <DatePicker
                selected={activeFilters.date}
                onSelect={(date) => {
                  setActiveFilters({ ...activeFilters, date });
                }}
                onClick={() =>
                  activeFilters.date &&
                  setActiveFilters({ ...activeFilters, date: null })
                }
                icon={activeFilters.date ? CircleX : CalendarIcon}
                placeholder="Due date"
                className="border-none bg-transparent w-full"
              />
            </div>
          </>
        )}
      />
      {isPursuitTaskCalendarView ? (
        <div className="p-4">
          <PursuitCalendar
            events={filteredData.map((task) => ({
              day: new Date(task.due_date),
              events: [
                {
                  id: task.id,
                  name: task.title,
                  onClick: () => navigate(`./${task.id}`),
                  icon: taskPriorities.find((p) => p.value === task.priority)
                    .label,
                  color: taskPriorities.find((p) => p.value === task.priority)
                    .color,
                },
              ],
            }))}
          />
        </div>
      ) : (
        <PursuitTasksKanban
          data={filteredData}
          pursuit_id={pursuit_id}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}
